import { apiUrl } from "../../lib/api";

/** AuthKit entry. Optional slug lands the owner in that workspace after login. */
export function authKitLoginUrl(slug?: string): string {
  const next = slug
    ? `/login?welcome=1&slug=${encodeURIComponent(slug)}`
    : "/login?welcome=1";
  return apiUrl(`/auth/login?next=${encodeURIComponent(next)}`);
}
